import React, { useEffect, useState } from "react";
import { Input } from "../../Helpers/Input/Input";
import { Icon } from "leaflet";
import {
	MapContainer,
	Marker,
	TileLayer,
	useMap,
	useMapEvents,
} from "react-leaflet";
import MapLocationSearch from "../../Maps/FeatureGroup/MapLocationSearch";
import trans from "../../../utils";

export default function UserLocation({ addData }) {
	const [position, setPosition] = useState(null);
	const [latlng, setLatLng] = useState({ lat: null, lon: null });

	Icon.Default.mergeOptions({
		iconUrl: "https://www.svgrepo.com/show/513317/location-pin.svg",
	});

	function LocationMarker() {
		useMapEvents({
			click(e) {
				setPosition(e.latlng);
				addData.setFieldValue("latitude", Number(e.latlng.lat));
				addData.setFieldValue("longitude", Number(e.latlng.lng));
			},
		});
		return position === null ? null : <Marker position={position}></Marker>;
	}
	function MapFlyTo({ latlng }) {
		const map = useMap();

		useEffect(() => {
			if (latlng?.lat && latlng?.lon) {
				map.flyTo([Number(latlng.lat), Number(latlng.lon)], map.getZoom(), {
					animate: true,
					duration: 1.5,
				});
			}
		}, [latlng.lat, latlng.lon, map]);

		return null;
	}
	useEffect(() => {
		const lat = addData.values.latitude;
		const lng = addData.values.longitude;
		setLatLng({ lat: lat, lon: lng });
		const isValidNumber = (val) => {
			if (typeof val !== "string" && typeof val !== "number") return false;
			const trimmed = val.toString().trim();
			return trimmed !== "" && !isNaN(Number(trimmed));
		};

		if (isValidNumber(lat) && isValidNumber(lng)) {
			setPosition({
				lat: parseFloat(lat),
				lng: parseFloat(lng),
			});
		} else {
			setPosition(null);
		}
	}, [addData.values.latitude, addData.values.longitude]);

	return (
		<div className="userinfo mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("user location")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<Input
						title={trans("Latitude")}
						type="text"
						placeholder={trans("Ex. 30.15484612")}
						formstyle="form-input"
						id="latitude"
						name="latitude"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.latitude}
						touched={addData.touched.latitude}
						value={addData.values.latitude || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Longitude")}
						type="text"
						placeholder={trans("Ex. 33.45235645")}
						formstyle="form-input"
						id="longitude"
						name="longitude"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.longitude}
						touched={addData.touched.longitude}
						value={addData.values.longitude || ""}
					/>
				</div>
			</div>

			<p className="form-label text-uppercase">
				{trans("Choose Location from map")}
			</p>

			<MapContainer
				center={position ? [position.lat, position.lng] : [23.8859, 45.0792]} // Update center when position changes
				zoom={5}
				style={{ height: "300px", width: "100%", borderRadius: "8px" }}
			>
				<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
				<MapLocationSearch />
				<MapFlyTo latlng={latlng} />
				<LocationMarker />
			</MapContainer>
		</div>
	);
}
